module.exports = __webpack_public_path__ + "media/Pokemon.70afa3a0.mp3";